/* eslint-disable react/prop-types */
import usePageTitle from '../../hooks/usePageTitle';

// SEO helper: sets the browser tab title for the page and, when the page has
// no visible top-level heading, renders a screen-reader-only h1 so every page
// has exactly one h1 for search engines and assistive tech.

type Props = {
  title?: string | null;
  h1?: string | null;
};

const PageSeo = ({ title, h1 }: Props) => {
  usePageTitle(title);
  return h1 ? <h1 className="sr-only">{h1}</h1> : null;
};

export default PageSeo;
